import scorableItemNumberingService from '../../../services/questionView/ScorableItemNumberingService';
import questionReader from '../../../store/readHelpers/QuestionReader';
import sessionReader from '../../../store/readHelpers/SessionReader';

const questionDisplayFlagSelector = {
    selectExtraClassList(question, viewMedia, isHorizontal, noTitle) {
        const printStyle = sessionReader.getPrintParam('printStyle');
        const classList = [viewMedia];

        if (!isHorizontal) {
            classList.push('question-margin');
            classList.push('right');
        }

        if (printStyle) {
            classList.push(`print-style-${printStyle}`);
        }

        if (noTitle) {
            classList.push('no-title');
        }

        if (sessionReader.isViewMediaPrintOrPdf()) {
            classList.push('print');
        }

        if (sessionReader.getPrintParam('noMargins')) {
            classList.push('noMargins');
        }

        if (questionReader.isExtendedRenderingActivated(question)) {
            if (printStyle) {
                classList.push('extendedMarginStyleForPrint');
            } else {
                classList.push('extendedMarginStyle');
            }

            if (questionReader.isGapMatchQuestion(question) && !sessionReader.isViewMediaPrintOrPdf()) {
                const horizontalTokenPosition = ['right', 'left'].includes(question.responseModels[0].tokenPosition);
                if (horizontalTokenPosition) {
                    classList.push('extendedMarginStyleForGapMatch');
                }
            }
        }

        if (questionReader.isWordFormationQuestion(question)) {
            classList.push('extendedMarginStyleForWF');
        }

        return classList;
    },

    selectScorableItems(useNumberPerInteraction, isHorizontal, question, responseIdentifier) {
        if (!useNumberPerInteraction) {
            return null;
        }

        return isHorizontal
            ? scorableItemNumberingService.getScorableItemsInInteraction(question.contentRevisionId, responseIdentifier)
            : scorableItemNumberingService.getScorableItemsInQuestion(question.contentRevisionId);
    },

    selectProps(ownProps) {
        const {
            question,
            responseIdentifier,
            isHorizontal,
            viewMedia,
            noTitle,
        } = ownProps;

        const useNumberPerInteraction = scorableItemNumberingService.useNumberPerInteraction();

        return {
            useNumberPerInteraction,
            extraClassList: this.selectExtraClassList(question, viewMedia, isHorizontal, noTitle),
            scorableItems: this.selectScorableItems(useNumberPerInteraction, isHorizontal, question, responseIdentifier),
        };
    },
};

export default questionDisplayFlagSelector;
